<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="三维矿山列表" name="1">
      <MineAdd :updataID='updataID'></MineAdd>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import MineAdd from '../../../../static/form/MineAdd.vue'
export default {
  components: {
    MineAdd
  },
  data()
  {
    return {
      activeName: '1',
      updataID: this.$route.query.id
    }
  },
  methods: {
    handleClick(tab, event)
    {
      this.$router.push({path: '/FinInfo'})
      this.$store.commit('onActiveName', tab.name)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/MineUpdate.vue